import React from 'react';

interface AvatarProps {
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  className = ''
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      className={className}
      fill="none" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="8" r="3.5" />
      <path d="M20,20 a8,8 0 0,0 -16,0" />
    </svg>
  );
};

export default Avatar;
